import data from "../../../../../src/RadioGroup/RadioGroup.docs.json";
import { RadioGroup, Radio, Box } from '@primer/components';
import { CheckIcon, XIcon, AlertIcon } from '@primer/octicons-react';
import * as React from 'react';
export default {
  data,
  RadioGroup,
  Radio,
  Box,
  CheckIcon,
  XIcon,
  AlertIcon,
  React
};